import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectTotalPrice } from '../../selectors/checkoutInfo';
import { selectActiveServiceId } from '../../selectors/publishTerms';
import { Checkout } from './Checkout';

export const CheckoutContainer = () => {
  const activeService = useSelector(selectActiveServiceId);
  const totalPrice = useSelector(selectTotalPrice);

  if (!activeService || !totalPrice) {
    return null;
  }

  return (
    <Checkout />
  );
};
